export const schema = {
  'Tên học sinh': {
    prop: 'name',
    type: String
  },
  'Mã số': {
    prop: 'code',
    type: String
  },
  'Ngày sinh': {
    prop: 'dob',
    type: String
  },
  'Giới tính': {
    prop: 'gender',
    type: String
  },
  Lớp: {
    prop: 'class',
    type: String
  },
  'Trạng thái': {
    prop: 'status',
    type: String
  },
  'Mức thu/giảm': {
    prop: 'price',
    type: String
  },
  'Kiểu giảm trừ': {
    prop: 'type',
    type: String
  },
  'Ghi chú riêng': {
    prop: 'notes',
    type: String
  }
}
export function dataExampleFile(router, isSubFee) {
  let arr = [
    {
      dob: '27/04/2011',
      code: '6603',
      currentClass: '6A4',
      name: 'Nguyễn Khánh Huyền',
      status: 'Đang học',
      gender: 'Nữ',
      money: '2000000',
      type: 'VND',
      notes: ''
    }
  ]
  if (router === 'priority' && isSubFee === false) {
    arr.push({
      name: 'Nguyễn Khánh Huyền',
      code: '6603',
      dob: '27/04/2011',
      gender: 'Nữ',
      currentClass: '6A4',
      status: 'Đang học',
      money: '20',
      type: '%',
      notes: ''
    })
  }
  return arr
}
export let headerSampleFile = [
  { text: 'Tên học sinh', value: 'name' },
  { text: 'Mã số', value: 'code' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Giới tính', value: 'gender' },
  { text: 'Lớp', value: 'currentClass' },
  { text: 'Trạng thái', value: 'status' },
  { text: 'Mức thu/giảm', value: 'money' },
  { text: 'Kiểu giảm trừ', value: 'type' },
  { text: 'Ghi chú riêng', value: 'notes' },
  { text: 'Dữ liệu khi upload lên hệ thống được tính từ dòng 2', value: '' }
]

export function headerTable(title) {
  let header = [
    {
      text: title,
      value: 'title',
      align: 'left',
      sortable: false,
      show: true,
      width: '26%'
    },
    {
      text: 'Độ ưu tiên',
      value: 'rank',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%'
    },
    {
      text: 'Ghi chú',
      value: 'note',
      align: 'left',
      sortable: false,
      show: true,
      width: '24%'
    },
    {
      text: 'Thao tác',
      align: 'center',
      value: 'action',
      sortable: false,
      show: true,
      width: '10%'
    }
  ]
  if (title === 'Khoản phí') {
    header.splice(2, 0, {
      text: 'Loại hóa đơn',
      value: 'kind',
      align: 'left',
    })
  }
  if (title !== 'Khoản phí') {
    header.splice(2, 0, {
      text: 'Áp dụng với khoản phí thu/đóng',
      value: 'head_fee_apply.title',
      align: 'left',
      sortable: false,
      show: true,
      width: '26%'
    })
  }
  return header
}
export function headerTableFee(router, isSubFee) {
  if (router === 'normal' && isSubFee === true) {
    return headerTable('Khoản truy thu')
  } else if (router === 'priority' && isSubFee === true) {
    return headerTable('Khoản hoàn trả')
  } else if (router === 'normal' && isSubFee === false) {
    return headerTable('Khoản phí')
  } else if (router === 'priority' && isSubFee === false) {
    return headerTable('Khoản giảm trừ')
  } else return ''
}
export function header(title, price) {
  return [
    {
      text: title,
      value: 'period.title',
      align: 'left',
      sortable: false,
      show: true,
      width: '50%'
    },
    {
      text: price,
      value: 'price',
      align: 'left',
      sortable: false,
      show: true,
      width: '25%'
    },
    {
      text: 'Thao tác',
      align: 'center',
      value: 'action',
      sortable: false,
      show: true,
      width: '25%'
    }
  ]
}
export function headerPaymentPeriodTable(router, isSubFee) {
  if (router === 'normal' && isSubFee === true) {
    return header('Kỳ truy thu cụ thể', 'Mức truy thu (VNĐ)')
  } else if (router === 'priority' && isSubFee === true) {
    return header('Hoàn trả tại kỳ đóng', 'Mức hoàn trả')
  } else if (router === 'normal' && isSubFee === false) {
    return header('Kỳ đóng cụ thể', 'Mức đóng (VNĐ)')
  } else if (router === 'priority' && isSubFee === false) {
    return header('Kỳ giảm trừ', 'Mức giảm trừ')
  } else return ''
}
export function placeHolderInput(router, isSubFee, type) {
  if (router === 'normal' && isSubFee === true) {
    return 'Mức truy thu (VNĐ)'
  } else if (router === 'priority' && isSubFee === true) {
    return type === 'fixed' ? 'Mức hoàn trả (VNĐ)' : 'Mức hoàn trả (%)'
  } else if (router === 'normal' && isSubFee === false) {
    return 'Mức đóng (VNĐ)'
  } else if (router === 'priority' && isSubFee === false) {
    return type === 'fixed' ? 'Mức giảm trừ (VNĐ)' : 'Mức giảm trừ (%)'
  } else return ''
}
